import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import SvcVisumEtRepertum from "@/services/VisumEtRepertum";

@Module({ dynamic: true, namespaced: true, store, name: "visumEtRepertum" })
class VisumEtRepertumStore extends VuexModule {
  listVisum: any[] = [];
  loading = false;

  @Mutation
  SET_LIST(data: any[]) {
    this.listVisum = data;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async getByRegister(reg): Promise<void> {
    this.SET_LOADING(true);
    this.SET_LIST([]);
    const dt = await SvcVisumEtRepertum.getByReg(reg).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_LIST(dt.data ? dt.data : []);
  }

  @Action reset() {
    this.SET_LIST([]);
  }
}

export const storeVisumEtRepertum = getModule(VisumEtRepertumStore);
export default getModule(VisumEtRepertumStore);
